import { ClipLoader } from 'react-spinners';
import styled from 'styled-components';
import { getStateColor } from "../../utils/getStateColor";
const getBackgroundColor = (theme, color, state, active) => {
  if (active) {
    return getStateColor(theme?.colors?.primary, state);
  }
  if (color === 'primary') {
    return getStateColor(theme?.colors?.primary, state);
  } else if (color === 'secondary') {
    return getStateColor(theme?.colors?.secondary, state);
  } else if (color === 'danger') {
    return getStateColor(theme?.colors?.error, state);
  } else if (color === 'secondaryAlt') {
    return getStateColor(theme?.colors?.secondaryL1, state);
  } else if (color === 'ghost') {
    if (state === 'normal') return 'transparent';else return getStateColor(theme?.colors?.secondaryD1, state);
  }
};
export const IconButtonContainer = styled.button`
  border-radius: ${_ref => {
  let {
    radius
  } = _ref;
  if (radius === 'square') return '6px';else if (radius === 'round') return '100%';
}};

  background-color: ${_ref2 => {
  let {
    theme,
    color,
    active
  } = _ref2;
  return getBackgroundColor(theme, color, 'normal', active ?? false);
}};

  width: ${_ref3 => {
  let {
    size
  } = _ref3;
  if (size === 'xs') return '32px';else if (size === 'sm') return '48px';else if (size === 'md') return '56px';else if (size === 'lg') return '64px';
}};

  height: ${_ref4 => {
  let {
    size
  } = _ref4;
  if (size === 'xs') return '32px';else if (size === 'sm') return '48px';else if (size === 'md') return '56px';else if (size === 'lg') return '64px';
}};

  &:disabled {
    opacity: 30%;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background-color: ${_ref5 => {
  let {
    theme,
    color,
    active
  } = _ref5;
  return getBackgroundColor(theme, color, 'hover', active ?? false);
}};
  }

  &:not(:disabled):active {
    background-color: ${_ref6 => {
  let {
    theme,
    color,
    active
  } = _ref6;
  return getBackgroundColor(theme, color, 'pressed', active ?? false);
}};
  }

  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const StyledClipLoader = styled(ClipLoader).attrs(_ref7 => {
  let {
    size,
    color
  } = _ref7;
  return {
    color,
    size: size === 'sm' ? 20 : size === 'md' ? 24 : size === 'lg' ? 28 : 20
  };
})`
  position: absolute;
`;